var render, staticRenderFns
import script from "./eb-dropdown-item.vue?vue&type=script&lang=js&"
export * from "./eb-dropdown-item.vue?vue&type=script&lang=js&"
import style0 from "./eb-dropdown-item.vue?vue&type=style&index=0&id=4a263f12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a263f12",
  null
  
)

export default component.exports